import { render, staticRenderFns } from "./process-role-table.vue?vue&type=template&id=6428c960&"
import script from "./process-role-table.vue?vue&type=script&lang=js&"
export * from "./process-role-table.vue?vue&type=script&lang=js&"
import style0 from "./process-role-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports